import React from "react";
import "./WaveLoader.css";

const WaveLoader = () => {
  return (
    <div className="wave-loader">
      <span className="wave"></span>
      <span className="wave"></span>
      <span className="wave"></span>
      <span className="wave"></span>
      <span className="wave"></span>
    </div>
  );
};

export default WaveLoader;
